import { render, staticRenderFns } from "./Consumables.vue?vue&type=template&id=5c96a588&scoped=true&"
import script from "./Consumables.vue?vue&type=script&lang=ts&"
export * from "./Consumables.vue?vue&type=script&lang=ts&"
import style0 from "./Consumables.vue?vue&type=style&index=0&id=5c96a588&scoped=true&lang=css&"
import style1 from "./Consumables.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c96a588",
  null
  
)

export default component.exports